import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const Gravatar: React.FC<IconProps> = ({ size, style, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      width={size ?? '20'}
      height={size ?? '20'}
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 256 256"
      data-testid="gravatar-icon"
    >
      <path
        fill={color ?? '#1E8CBE'}
        d="M128 0c-14.144 0-25.6 11.456-25.6 25.6v89.6c0 14.128 11.456 25.6 25.6 25.6 14.144 0 25.6-11.472 25.6-25.6V55.584c29.824 10.56 51.2 38.976 51.2 72.416 0 42.4-34.4 76.8-76.8 76.8S51.2 170.4 51.2 128c0-21.216 8.592-40.416 22.496-54.304 10-10 10-26.208 0-36.208s-26.208-10-36.208 0C14.336 60.64 0 92.64 0 128c0 70.688 57.312 128 128 128s128-57.312 128-128S198.688 0 128 0"
      />
    </svg>
  );
};

export default Gravatar;
